import { Checkbox, ListItem, ListItemText } from "@mui/material"

const CmPlayerEventsListItem = ({ table, eventKey, eventValue, checked, onChange }) => (
    <ListItem
        secondaryAction={
            table && <Checkbox
                edge="end"
                checked={checked}
                onChange={() => onChange(table, eventKey)}
            />
        }
    >
        <ListItemText primary={`${eventKey} = ${eventValue}`} />
    </ListItem>
)

export default CmPlayerEventsListItem
